import React from 'react';
import { WizardCard } from './fdicChrome';

const FileIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
    <path d="M6 3h9l3 3v15H6z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M14 3v4h4" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
  </svg>
);

const Step3CaseStatus = ({ data, onNext }) => {
  const status = data.caseStatus || 'Ongoing Case ID';

  return (
    <WizardCard headerIcon={<FileIcon />} headerLabel="Case Status">
      <div className="px-5 pt-5">
        <h2 className="font-serif text-[22px] text-[#1a2b3c]">Case Status</h2>
      </div>

      <div className="px-5 pt-4">
        <div className="text-[13px] text-gray-500 mb-2">Current Status:</div>
        <span className="inline-flex items-center gap-2 bg-[#dff3e4] text-[#1f5c3a] text-[13px] font-semibold px-3 py-1.5 rounded-full">
          <span className="w-2 h-2 rounded-full bg-[#1f5c3a]" />
          {status}
        </span>
      </div>

      <div className="px-5 pt-5 pb-4">
        <div className="bg-gray-50 border border-gray-100 rounded-lg p-4">
          <div className="text-[14px] font-semibold text-[#1a2b3c] mb-2">
            Verification Notice
          </div>
          <p className="text-[13px] text-gray-600 leading-6">
            This session is being monitored for quality assurance. The information provided is
            confidential and intended solely for the use of the individual or entity to whom it
            is addressed. Unauthorized access is prohibited by law.
          </p>
        </div>
      </div>

      <div className="p-5">
        <button
          onClick={onNext}
          className="w-full bg-[#22a06b] hover:bg-[#1f8f60] text-white text-[13px] font-semibold tracking-[0.15em] uppercase py-4 rounded-md"
        >
          Confirm &amp; Close
        </button>
      </div>
    </WizardCard>
  );
};

export default Step3CaseStatus;